import { Landing } from "@/components/pages/landing";
import type { Activity } from "@lib/activity";
import { type DoubleOptinPage } from "@lib/config/types";
import type { Config } from "@lib/config/utils";
import { createRoute } from "@tanstack/react-router";
import { Route as rootRoute, getContext } from "./root";
import { usePageTracking } from "@/lib/tracking";
import { DoubleOptinV2Form } from "@/components/forms/double-optin-v2";
import { type Ticket } from "@lib/ticket";

export type DoubleOptinV2Props = {
  activity: Activity;
  config: Config;
  encodedActivityId: string;
  ticket: Ticket;
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/flow/double_optin/v2/$encodedActivityId",
  loader: ({ params }) => ({ ...getContext<DoubleOptinV2Props>(), ...params }),
  component: function Page() {
    const props = Route.useLoaderData();
    usePageTracking(props.encodedActivityId, {
      type: "double_optin",
      number: 1,
    });

    return <DoubleOptinV2Page {...props} />;
  },
});

export function DoubleOptinV2Page({
  activity,
  encodedActivityId,
  config,
  ticket,
}: DoubleOptinV2Props) {
  return (
    <DoubleOptinV2Form encodedActivityId={encodedActivityId} ticket={ticket}>
      <Landing
        activity={activity}
        config={config as DoubleOptinPage}
        page="landing"
        ticket={ticket}
        flowConsents={activity.claimConsents}
      />
    </DoubleOptinV2Form>
  );
}
